import styled from "styled-components";
import { device } from "../../services/styles";

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  @media ${device.tabletLarge} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;
export const Flex = styled.div`
  display: flex;
  @media print {
    display: none;
  }
`;

export const Title = styled.h1`
  font-size: 30px;
  line-height: 36px;
  font-weight: 900;
  margin: 0 0 10px 0;
`;

export const Date = styled.span`
  font-size: 13px;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #f1f1f1;
  margin-right: 10px;
`;

export const Author = styled.span`
  font-size: 14px;
  line-height: 1;
`;

export const PrintButton = styled.button`
  display: flex;
  align-items: center;
  background-color: #fff;
  color: #4d75e1;
  border: 1px solid #4d75e1;
  border-radius: 4px;
  padding: 4px 8px;
  text-transform: uppercase;
  box-sizing: border-box;
  font-size: 13px;
  margin-left: 10px;
  cursor: pointer;
`;

export const MainImage = styled.img`
  width: 100%;
`;
export const ImgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: 100%;
  width: auto;
  max-height: 300px;
  overflow: hidden;
  margin: 16px auto 20px auto;
  @media ${device.tablet} {
    max-height: 300px;
  }
`;

export const Lead = styled.h3`
  width: 100%;
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  margin: 0 0 20px 0;
`;
